import { useState } from 'react'

import { initRequestParam } from 'constants/constants'

import { useAlertStatusStore } from 'store/alertStatusStore'
import { useCurrentStatusStore } from 'store/currentStatusStore'
import { getAPI } from 'utils/getAPI'

import type { AlertSummary, GetAlertSummaryAlertSummaryGetRequest, GetOrderAlertOrderAlertGetRequest, OrderAlertList, ResponseResult } from 'api-client'
import type { ErrorResponse } from 'types/types'

export const useOrderAlert = () => {
  const [orderAlert, setOrderAlert] = useState<OrderAlertList>(initRequestParam)
  const [alertSummary, setAlertSummary] = useState<AlertSummary | undefined>(undefined)
  const [isLoading, setIsLoading] = useState(false)
  const [isAlertSummaryLoading, setIsAlertSummaryLoading] = useState(false)
  const [result, setResult] = useState<ResponseResult>()
  const { setCurrentStatuses } = useCurrentStatusStore()
  const { setAlertStatus } = useAlertStatusStore()

  const fetchOrderAlert = async (searchParam: GetOrderAlertOrderAlertGetRequest) => {
    setOrderAlert(initRequestParam)
    setResult(undefined)
    setIsLoading(true)

    try {
      const api = await getAPI()
      if (!api) return undefined

      const response = await api.getOrderAlertOrderAlertGet({
        ...searchParam,
        centerId: undefined,
        centerIds: searchParam.centerIds && searchParam.centerIds.length > 0 ? searchParam.centerIds : undefined,
        orgSupplierIds: searchParam.orgSupplierIds && searchParam.orgSupplierIds.length > 0 ? searchParam.orgSupplierIds : undefined,
        // orgSupplierId: searchParam.orgSupplierId || undefined,
        sort: searchParam.sort,
      })

      setOrderAlert(response.data)
      setResult(response.result)
      setCurrentStatuses(response.result.systemInfo?.sysCurrentStatus)
      return response
    } catch (e) {
      const error = e as ErrorResponse
      setResult({
        status: 'error',
        message: error.response && error.response.status === 422 ? '入力値に誤りがあります。' : `オーダーアラート取得でエラーが発生しました。`,
        systemDate: null,
        pageNo: 0,
        systemInfo: null,
      })
      return undefined
    } finally {
      setIsLoading(false)
    }
  }

  const fetchAlertSummary = async (searchParam: GetAlertSummaryAlertSummaryGetRequest, sideBarAlertStatusNonEmpty: boolean = false) => {
    setAlertSummary(undefined)
    setIsAlertSummaryLoading(true)

    try {
      const api = await getAPI()
      if (!api) return undefined

      const response = await api.getAlertSummaryAlertSummaryGet({
        ...searchParam,
        centerIds: searchParam.centerIds && searchParam.centerIds.length > 0 ? searchParam.centerIds : undefined,
        orgSupplierIds: searchParam.orgSupplierIds && searchParam.orgSupplierIds.length > 0 ? searchParam.orgSupplierIds : undefined,
        orgSupplierId: searchParam.orgSupplierId || undefined,
      })

      setAlertSummary(response.data)
      if (sideBarAlertStatusNonEmpty) {
        return response
      }
      setAlertStatus(response.data)
      return response
    } catch (e) {
      const error = e as ErrorResponse
      setResult({
        status: 'error',
        message: error.response && error.response.status === 422 ? '入力値に誤りがあります。' : `アラート情報取得でエラーが発生しました。`,
        systemDate: null,
        pageNo: 0,
        systemInfo: null,
      })
      return undefined
    } finally {
      setIsAlertSummaryLoading(false)
    }
  }

  return {
    orderAlert,
    alertSummary,
    fetchOrderAlert,
    fetchAlertSummary,
    result,
    isLoading,
    isAlertSummaryLoading,
  }
}
